export default {
      id: "statistics-usage",
      viewBox: "0 0 36.57 33.62",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#statistics-usage",
      toString: function () {
        return this.url;
      }
    }